import { useId, useState, useEffect } from "react";
import classNames from "classnames";

export default function TextField({
  label,
  placeholder,
  value,
  onChange,
  id,
  className,
  icon,
  errors = [],
  disabled,
}) {
  const inputId = id || useId();

  if (typeof onChange !== "function")
    console.debug("A text field doesn't have an onChange callback");

  const [isValid, setIsValid] = useState(errors.length == 0);

  useEffect(() => {
    setIsValid(errors.length == 0);
  }, [errors]);

  const handleChange = (event) => {
    if (typeof onChange === "function")
      onChange(event.target.value);

    setIsValid(true);
  };

  return (
    <div className="inpt-grp">
      {label && (
        <label htmlFor={inputId} className="lbl">{label}</label>
      )}

      {icon && (<div className="inpt-text__icon">{icon}</div>)}
      <input
        id={inputId}
        type="text"
        className={className || classNames("inpt-text", { "inpt-text--with-icon": icon, "inpt--error": !isValid })}
        placeholder={placeholder}
        onChange={handleChange}
        // `?? ""` keeps the input controlled for its whole lifetime: the store's
        // defaults are `undefined`, and React would otherwise start it
        // uncontrolled and flip on the first keystroke. `??` rather than `||` so
        // a legitimate 0 (e.g. `order`) isn't blanked out.
        value={value ?? ""}
        disabled={disabled}
      />

      {!isValid && errors.map((error, index) => (
        <label key={index} className="lbl lbl--error">{error}</label>
      ))}
    </div>
  );
}
